import { motion } from "framer-motion";
import { PROJECTS } from "../data/content";

const SPANS = {
  wide: "md:col-span-7 h-[340px] md:h-[500px]",
  narrow: "md:col-span-5 h-[340px] md:h-[500px]",
  third: "md:col-span-4 h-[300px] md:h-[400px]",
  half: "md:col-span-6 h-[300px] md:h-[420px]",
  full: "md:col-span-12 h-[300px] md:h-[420px]",
};

const Projects = () => (
  <section id="projects" data-testid="projects-section" className="relative bg-white border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-wrap items-end justify-between gap-6 mb-14"
      >
        <div>
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-blueprint-accent mb-6">
            Selected Work
          </p>
          <h2 className="font-display font-extrabold tracking-tight leading-[1.02] text-4xl md:text-5xl text-prussian">
            Concrete proof.
          </h2>
        </div>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-400">
          2019 — 2026 Archive · Real Work, Real Photos
        </p>
      </motion.div>

      <div className="grid md:grid-cols-12 gap-5">
        {PROJECTS.map((p, i) => (
          <motion.figure
            key={p.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: (i % 2) * 0.1, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`project-card-${i + 1}`}
            className={`group relative overflow-hidden border border-slate-200 col-span-1 ${SPANS[p.span]}`}
          >
            <img
              src={p.image}
              alt={`${p.name} — ${p.type}, ${p.location}`}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-prussian/85 via-prussian/10 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="absolute top-3 left-3 font-mono text-white/80 select-none" aria-hidden>+</span>
            <span className="absolute top-3 right-3 font-mono text-white/80 select-none" aria-hidden>+</span>
            <figcaption className="absolute bottom-0 inset-x-0 p-5 md:p-7 flex items-end justify-between gap-4">
              <div>
                <p className="font-mono text-[9px] md:text-[10px] tracking-[0.25em] uppercase text-blueprint-line mb-2">
                  {p.type} — {p.location}
                </p>
                <h3 className="font-display font-bold tracking-tight text-xl md:text-3xl text-white">
                  {p.name}
                </h3>
              </div>
              <span className="font-mono text-[10px] md:text-xs tracking-widest text-white/70 border border-white/30 px-2.5 py-1.5 shrink-0">
                {p.tag}
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
